import { Button } from "flowbite-react";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import Personnel1 from "../../img/bradley.jpeg";
import Personnel2 from "../../img/jeff.jpeg";
import Personnel3 from "../../img/angela.jpeg";
import Personnel4 from "../../img/chen-yi.jpeg";
import Personnel5 from "../../img/shanice.jpeg";
import Personnel6 from "../../img/debbie.jpeg";

function Personnel() {
  const navigate = useNavigate();
  const [showMore1, setShowMore1] = useState(false);
  const [showMore2, setShowMore2] = useState(false);
  const [showMore3, setShowMore3] = useState(false);
  const [showMore4, setShowMore4] = useState(false);
  const [showMore5, setShowMore5] = useState(false);
  const [showMore6, setShowMore6] = useState(false);

  return (
    <section className="text-[#244566] text-center bg-[#e9eef4] flex flex-col justify-center items-center space-y-14 pt-6 pb-14">
      <h3 className="text-2xl font-semibold">OUR KEY PERSONNEL</h3>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 w-[60%] sm:w-[90%] lg:w-[60%]">
        <div className="card-transparent">
          <img
            alt=""
            src={Personnel1}
            className="w-[60%] sm:max-w-[200px] lg:max-w-none lg:w-[80%]"
          />
          <h4 className="text-xl font-bold uppercase">BRADLEY SIM</h4>
          <p className="pb-2">Managing Partner</p>
          <div className="relative w-full">
            {showMore1 ? (
              <p className="mb-2 text-justify">
                Bradley as the founder thinks globally, act locally. He has been in the banking business for over 15 years and believes there are no unapproved loans, as long as the client wants to borrow. Bradley and his team want Discoverloan to work with all their partners such as property agencies and developers in Malaysia to be the market leader.
                <br />
                <br />
                He is committed to building strong partnerships across Malaysia’s property agencies and developers to deliver seamless, market-leading loan experiences. Under his leadership, Discoverloan combines deep industry expertise, trusted local relationships, and a relentless drive for innovation to make homeownership and property financing simpler and more accessible for everyone.
              </p>
            ) : null}

            <button
              className="!text-[#244565] text-xs !bg-transparent border border-[#244565] rounded-md py-2 w-[80%] md:w-[70%] hover:shadow-lg hover:-translate-x-px hover:shadow-[#244565]/50"
              onClick={() => setShowMore1((prev) => !prev)}
            >
              {showMore1 ? "Show less" : "Learn more"}
            </button>
          </div>
        </div>
        <div className="card-transparent">
          <img
            alt=""
            src={Personnel2}
            className="w-[60%] sm:max-w-[200px] lg:max-w-none lg:w-[80%]"
          />
          <h4 className="text-xl font-bold uppercase">Jeff Phong</h4>
          <p className="pb-2">Managing Partner</p>
          <div className="relative w-full">
            {showMore2 ? (
              <div className="mb-2 text-justify">
                <p>
                  Jeff is a distinguished and highly
                  accomplished group leader with over two decades of
                  unparalleled expertise in financial advisory services,
                  spanning insurance, banking, and investment. As an ACCA
                  finalist graduate, Jeff has garnered numerous international
                  accolades during his early career, having worked with a
                  prestigious foreign bank and Hong Leong Assurance Berhad,
                  Malaysia’s leading domestic insurance provider.
                  <br /><br />

                  Beyond his remarkable achievements in production, Jeff has
                  taken on multifaceted leadership roles, excelling in coaching
                  and training new agents. His mentorship has consistently
                  yielded extraordinary results, cultivating a generation of
                  top-tier professionals, including multiple Million Dollar
                  Round Table (MDRT) qualifiers who have thrived under his
                  guidance. Today, Jeff manages an impressive portfolio of over
                  1,000 clients, with total assets under management (AUM)
                  exceeding RM100 million.
                  <br /><br />

                  Jeff’s philosophy is anchored in the belief that a strong
                  system, the right talent, innovation, and unwavering
                  compliance are the pillars of sustainable growth. By adhering
                  to these principles, he ensures that his clients receive
                  unparalleled financial advice tailored to their needs.
                  Integrity and credibility are the cornerstones of his
                  practice, fostering trust and nurturing long-lasting
                  relationships with his clients. His steadfast commitment to
                  these values continues to drive both his team and the
                  organization toward excellence and enduring success.
                </p>
              </div>
            ) : null}
            <button
              className="!text-[#244565] text-xs !bg-transparent border border-[#244565] rounded-md py-2 w-[80%] md:w-[70%] hover:shadow-lg hover:-translate-x-px hover:shadow-[#244565]/50"
              onClick={() => setShowMore2((prev) => !prev)}
            >
              {showMore2 ? "Show less" : "Learn more"}
            </button>
          </div>
        </div>



        <div className="card-transparent">
          <img
            alt=""
            src={Personnel3}
            className="w-[60%] sm:max-w-[200px] lg:max-w-none lg:w-[80%]"
          />
          <h4 className="text-xl font-bold uppercase">Angela Ling</h4>
          <p className="pb-2">Strategic & Business Operations Manager</p>
          <div className="relative w-full">
            {showMore3 ? (
              <p className="mb-2 text-justify">
                Angela brings over 12 years of banking experience, specializing in outsourced mortgage operations to ensure compliance, enhance efficiency, and support sustainable growth. She manages a nationwide network of more than 15 agencies, consistently aligning operational execution with strategic objectives to deliver strong outcomes.
                <br /><br />
                Her contributions were recognized with the Most Valuable Person Award (2022) from Hong Leong Bank, underscoring her resilience, collaboration, and service quality. Angela is valued for fostering teamwork, building robust operational frameworks, and driving innovation within operations.
                <br /><br />
                She believes strong systems and efficient operations are key to sustainable business success, and now leads operational functions within the organization.
              </p>
            ) : null}
            <button
              className="!text-[#244565] text-xs !bg-transparent border border-[#244565] rounded-md py-2 w-[80%] md:w-[70%] hover:shadow-lg hover:-translate-x-px hover:shadow-[#244565]/50"
              onClick={() => setShowMore3((prev) => !prev)}
            >
              {showMore3 ? "Show less" : "Learn more"}
            </button>
          </div>
        </div>




        <div className="card-transparent">
          <img
            alt=""
            src={Personnel4}
            className="w-[60%] sm:max-w-[200px] lg:max-w-none lg:w-[80%]"
          />
          <h4 className="text-xl font-bold uppercase">Teoh Chen Yi</h4>
          <p className="pb-2">Insurance Specialist</p>
          <div className="relative w-full">
            {showMore4 ? (
              <p className="mb-2 text-justify">
                Chen Yi is a leading insurance professional with over 11 years of experience in customised protection planning and policy advisory. Recognised as the Nationwide HLA Rookie Award Unit Manager 2nd Runner-Up and a six-time International MDRT achiever, she is known for her passion, clarity, and consistent excellence.
                <br /><br />
                She specialises in bespoke protection strategies for individuals and families, turning complexity into simplicity, closing critical gaps, and delivering precise, forward-looking solutions. She applies a collaborative co-broking framework with fellow agents and leaders to expand reach and enhance closing efficiency.
                <br /><br />
                Her philosophy is that true financial planning transcends wealth—it is about preserving legacy, safeguarding security, and sustaining lasting peace of mind.
              </p>
            ) : null}
            <button
              className="!text-[#244565] text-xs !bg-transparent border border-[#244565] rounded-md py-2 w-[80%] md:w-[70%] hover:shadow-lg hover:-translate-x-px hover:shadow-[#244565]/50"
              onClick={() => setShowMore4((prev) => !prev)}
            >
              {showMore4 ? "Show less" : "Learn more"}
            </button>
          </div>
        </div>


        <div className="card-transparent">
          <img
            alt=""
            src={Personnel5}
            className="w-[60%] sm:max-w-[200px] lg:max-w-none lg:w-[80%]"
          />
          <h4 className="text-xl font-bold uppercase">Shanice Lim Lin</h4>
          <p className="pb-2">Senior Partner</p>
          <div className="relative w-full">
            {showMore5 ? (
              <p className="mb-2 text-justify">
                Shanice is a Registered Financial Planner (RFP), with over 15 years of experience in the financial services industry. She achieved MDRT status in under eight months, reflecting her exceptional expertise and commitment to excellence.
                <br /><br />
                She specialises in bespoke strategies for high-net-worth clients, delivering advice that evolves with their lives and goals. She adopts an integrated approach, combining wealth accumulation, protection, succession planning, and risk management into cohesive strategies tailored to each client.
                <br /><br />
                Shanice believes true financial planning goes beyond products—it is about building clarity, structure, and lasting financial confidence.
              </p>
            ) : null}
            <button
              className="!text-[#244565] text-xs !bg-transparent border border-[#244565] rounded-md py-2 w-[80%] md:w-[70%] hover:shadow-lg hover:-translate-x-px hover:shadow-[#244565]/50"
              onClick={() => setShowMore5((prev) => !prev)}
            >
              {showMore5 ? "Show less" : "Learn more"}
            </button>
          </div>
        </div>






        <div className="card-transparent">
          <img
            alt=""
            src={Personnel6}
            className="w-[60%] sm:max-w-[200px] lg:max-w-none lg:w-[80%]"
          />
          <h4 className="text-xl font-bold uppercase">Debbie Cheang</h4>
          <p className="pb-2">Accounts & Finance Manager</p>
          <div className="relative w-full">
            {showMore6 ? (
              <p className="mb-2 text-justify">
                Debbie is responsible for overseeing the company’s accounting functions, managing daily financial operations and ensuring accurate record-keeping. She holds a Bachelor’s Degree in Finance & Investment, bringing strong financial knowledge to support the company’s accounting processes.
                <br /> <br />
                She also ensures compliance with relevant financial regulations and internal policies, liaising with auditors, tax consultants, and regulatory bodies when required. Her attention to detail and commitment to continuous improvement contribute to the efficiency and reliability of the company’s financial operations.
              </p>
            ) : null}
            <button
              className="!text-[#244565] text-xs !bg-transparent border border-[#244565] rounded-md py-2 w-[80%] md:w-[70%] hover:shadow-lg hover:-translate-x-px hover:shadow-[#244565]/50"
              onClick={() => setShowMore6((prev) => !prev)}
            >
              {showMore6 ? "Show less" : "Learn more"}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Personnel;
